export const SESSION = 'SESSION';